<template>
    <div :id="id" class="row">
      <LmTextInput
        ref="inputFocus"
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="$emit('input', component)"
        label="Label"
        placeholder="Label"
      />
      <LmTextInput
        class="col-12 col-md-4"
        :id="id + 'nombre'"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        label="Nombre"
        placeholder="placeholder"
      />
      <LmColorPicker
        label="Color por defecto"
        :id="id ? id + '-default-color' : 'default-color'"
        @input="onInputColorPicker($event)"
        />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        label="Ancho vista escritorio"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <div class="col-12">
        <h5>Validation</h5>
        <div class="row align-items-center">
          <div class="custom-control custom-checkbox col-12 col-md-4 mt-1">
            <b-form-checkbox
              :name="component.formObjectToSendToServerProperty"
              v-model="validations.required"
              @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
              >
              required
            </b-form-checkbox>
          </div>
          <LmSelect
            v-if="component.componentName !== 'LmEditor'"
            :id="id + 'same-as'"
            class="col-12 col-md-4"
            v-model="validations.sameAs"
            :options="optionsSameAsValidation"
            label="El valor tiene que ser igual a"
            @input="onInputValidationSameAs(optionsSameAsValidation.content.find(e => e.value === validations.sameAs))"
          />
        </div>
      </div>
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
import LmColorPicker from '@/components/form/elements/LmColorPicker'

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false,
        sameAs: ''
      }
    }
  },
  methods: {
    onInputColorPicker (event) {
      this.component.componentProps.defaultValue = event
      this.$emit('input', this.component)
    }
  },
  components: {
    LmColorPicker
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  }
}
</script>
